import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['badge']

  connect() {
    this.unsaved = false
    this.formSubmitting = false

    this.element.addEventListener('change', this.markUnsaved)
    this.element.addEventListener('submit', this.handleFormSubmit)
    window.addEventListener('input:change', this.markUnsaved)
    window.addEventListener('turbo:before-visit', this.popupMessage, true)
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  }

  markUnsaved = () => {
    this.unsaved = true

    this.badgeTarget.classList.add('components--ui--pages--unsaved-changes--visible')
  }

  // Form submit triggers Turbo navigation (turbo:before-visit), so we track it
  // to avoid showing the "discard changes?" dialog when the user is saving.
  handleFormSubmit = () => {
    this.formSubmitting = true
  }

  // Catches refresh, URL changes, and tab close (browser shows its own generic message)
  handleBeforeUnload = (event) => {
    if (this.unsaved && !this.formSubmitting) {
      event.preventDefault()
      // Browsers require both preventDefault() and setting returnValue to show the dialog
      event.returnValue = ''
    }
  }

  // Catches in-app Turbo navigation (shows our custom message)
  popupMessage = event => {
    if (this.unsaved && !this.formSubmitting) {
      if (!window.confirm('Do you want to discard these unsaved changes?')) {
        event.preventDefault()
        return false
      }
    }
    return true
  }

  disconnect() {
    this.element.removeEventListener('change', this.markUnsaved)
    this.element.removeEventListener('submit', this.handleFormSubmit)
    window.removeEventListener('input:change', this.markUnsaved)
    window.removeEventListener('turbo:before-visit', this.popupMessage, true)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }
}
